let modals = Array.from(document.querySelectorAll(".modal"));
let modalOpeners = document.querySelectorAll(".modal_opener");
let modalClosers = document.querySelectorAll(".modal_closer");
let modalFades = document.querySelectorAll(".fade");

modalOpeners.forEach((modalOpener) => {
    modalOpener.addEventListener("pointerdown", function (e) {
        const modalTarget = this.dataset.modalTarget;
        openModal(modalTarget);
    });
});

modalClosers.forEach((modalCloser) => {
    modalCloser.addEventListener("pointerdown", function (e) {
        const modalTarget = this.dataset.modalTarget;
        let modal = modals.find((modal) => modal.id == modalTarget);
        modal && modal.classList.remove("show");

        pauseVideo();

        servObj.modals.isOpen = false;
        servObj.modals.id = null;

        // if (servObj.currentFrame && !servObj.pause) scenes[servObj.currentFrame].paused(false);

        if (this.dataset.modalTarget === "spec_modal") {
            const checkbox = document.getElementById("spec_checkbox");
            checkbox.checked = false;

            const event = new Event("change");
            checkbox.dispatchEvent(event);
        }
    });
});

modalFades.forEach((fade) => {
    fade.addEventListener("pointerdown", (e) => {
        if (e.target !== fade || fade.classList.contains("fade_not_closer") || e.target.id === "mode_selector") return;
        servObj.isModalOpen = false;
        let modal = e.target.closest(".modal");
        modal && modal.classList.remove("show");

        pauseVideo();
    });
});

export function openModal(id, onConfirm = null, onCancel = null, title = "", bodyText = "") {
    const servObj = window.servObj || parent.servObj;
    let modal = document.getElementById(id);
    if (!modal) {
        modal = parent.document.getElementById(id);
        if (!modal) {
            console.warn(`Модальное окно с ID "${id}" не найдено!`);
            return;
        }
    }

    const modalTitle = modal.querySelector(".modal-title");
    const modalBody = modal.querySelector(".modal_body_text p");
    const confirmBtn = modal.querySelector(".modal_btn-confirm");
    confirmBtn?.focus();
    if (title.length && modalTitle) modalTitle.textContent = title;
    if (bodyText.length && modalBody) modalBody.textContent = bodyText;
    modal.classList.add("show");
    servObj.modals.isOpen = true;
    servObj.modals.id = id;
    if (onConfirm) servObj.modals.onConfirm = onConfirm; // Сохраняем колбэк для "Да"
    if (onCancel) servObj.modals.onCancel = onCancel; // Сохраняем колбэк для "Нет"
}

export function closeModal(id) {
    const servObj = window.servObj || parent.servObj;
    const modal = document.getElementById(id) || parent.document.getElementById(id);
    modal.classList.remove("show");
    servObj.modals.isOpen = false;
    servObj.modals.id = null;
    servObj.modals.onConfirm = null; // Очищаем колбэки
    servObj.modals.onCancel = null;
}

export const openLocalPreloader = () => {
    const loader = document.getElementById("local-loader");
    const aside = document.querySelector(".wrap_side_menu");

    loader.classList.add("open");
    aside.classList.add("disable");
};

export const closeLocalPreloader = () => {
    const aside = document.querySelector(".wrap_side_menu");
    const loader = document.getElementById("local-loader");

    loader.classList.remove("open");
    aside.classList.remove("disable");
};

function pauseVideo() {
    const iframe = document.querySelector("#video_modal iframe");
    if (!iframe) return;

    const url = iframe.src;
    let message = null;

    // Определяем плеер по URL и готовим нужную команду
    if (url.includes("youtube.com")) {
        message = {
            event: "command",
            func: "pauseVideo",
            args: "",
        };
    } else if (url.includes("rutube.ru")) {
        message = {
            type: "player:pause",
            data: {},
        };
    } else if (url.includes("vimeo.com")) {
        message = {
            method: "pause",
        };
    }

    // Если мы распознали плеер, отправляем "записку"
    if (message) {
        iframe.contentWindow.postMessage(JSON.stringify(message), "*");
    }
}
